import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
let Tree = class Tree extends Vue {
    constructor() {
        super(...arguments);
        this.checkedId = "";
    }
    handleDefaultCheckedKeysChange(keys) {
        this.$nextTick(() => {
            keys.forEach((key) => {
                this.elTree.setCurrentKey(key);
            });
        });
    }
    isUndefined(val) {
        return "undefined" === typeof val;
    }
    handleCheckedChange(checkedNodes, checkedKeys) {
        this.$emit("check-change", checkedNodes, checkedKeys);
    }
    getTreeComponent() {
        return this.elTree;
    }
    handleNodeClick(data, node) {
        // console.log("data, node", data, node)
        this.checkedId = data.id;
        this.$emit("node-click", data, node);
    }
};
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], Tree.prototype, "treeData", void 0);
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], Tree.prototype, "defaultExpandedKeys", void 0);
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], Tree.prototype, "defaultCheckedKeys", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], Tree.prototype, "showCheckedBox", void 0);
tslib_1.__decorate([
    Prop({ type: Function, default: () => function () { } })
], Tree.prototype, "filterNode", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 14 })
], Tree.prototype, "fontLength", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: true })
], Tree.prototype, "showIcon", void 0);
tslib_1.__decorate([
    Ref()
], Tree.prototype, "elTree", void 0);
tslib_1.__decorate([
    Watch('defaultCheckedKeys', { immediate: true })
], Tree.prototype, "handleDefaultCheckedKeysChange", null);
Tree = tslib_1.__decorate([
    Component({
        name: 'Tree',
        filters: {
            splitFilename(e) {
                for (var t = /[\da-zA-Z]/, n = 0, r = 0; r < e.length; r++)
                    n < 9 && e.charAt(r),
                        n += t.test(e.charAt(r)) ? 1 : 2;
                return e;
            },
            disableTooltip(e, t) {
                for (var n = /[\da-zA-Z]/, r = 0, i = 0; i < e.length; i++)
                    if (n.test(e[i]) ? r++ : r += 2,
                        r >= t)
                        return !1;
                return !0;
            }
        }
    })
], Tree);
export default Tree;
